import { Injectable } from '@angular/core';
import { User } from '@common/models/user';
import { CommonService } from '@common/services/common.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    private currentUser: User;
    private isAuthenticated: boolean;

    constructor(private commonService: CommonService) {
        this.commonService.userService.currentUserSubject.subscribe((user) => (this.currentUser = user));
        this.commonService.userService.isAuthenticatedSubject.subscribe(
            (isAuthenticated) => (this.isAuthenticated = isAuthenticated)
        );
    }

    async canActivate() {
        if (!this.currentUser) {
            this.currentUser = await this.commonService.userService.getCurrentUser();
        }

        return this.isAuthenticated;
    }

    canActivateChild() {
        return this.canActivate();
    }
}
